import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import LoadingWrapper from '@ui/atoms/LoadingWrapper';

import { ILegalName, MemberInfo, SubscriptionInfo } from '@hooks/useMemberInfo';

import { keysToCamel } from '@utils/butter';
import { doesNotExist } from '@utils/general';

import { IActiveSubscriptionRx } from '@folx-types/medications';

import PlanCard, { IPlanCardWrapperContent } from './PlanCard.component';

interface IPlanCardWrapperProps {
	activePrescriptions: IActiveSubscriptionRx[];
	member?: MemberInfo & SubscriptionInfo & ILegalName;
}

const PlanCardWrapper: FC<IPlanCardWrapperProps> = ({ activePrescriptions, member }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "plan-card" }) {
				plan_header
				refill_description
				canceled_description
				past_due_description
				reactivate_label
				update_label
				estrogen_injectable_image
				estrogen_injectable_alt
				estrogen_sublingual_image
				estrogen_sublingual_alt
				estrogen_patch_image
				estrogen_patch_alt
				testosterone_injectable_image
				testosterone_injectable_alt
				testosterone_gel_image
				testosterone_gel_alt
				prep_sublingual_image
				prep_sublingual_alt
			}
		}
	`);

	const refinedContent: IPlanCardWrapperContent = keysToCamel(
		pageContent
	) as IPlanCardWrapperContent;

	const loading = doesNotExist(activePrescriptions) || doesNotExist(member);

	return (
		<LoadingWrapper loading={loading}>
			<PlanCard
				activePrescriptions={activePrescriptions}
				member={member}
				wrapperContent={refinedContent}
			/>
		</LoadingWrapper>
	);
};

export default PlanCardWrapper;
